import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.317969 41.1709L25 25L0.317969 8.8291C0.128027 8.98721 0 9.21631 0 9.48271V40.5172C0 40.7837 0.128027 41.0128 0.317969 41.1709Z",
			fill: "#F3F3F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.317383 41.1709C0.466797 41.2953 0.651855 41.3793 0.861426 41.3793H49.1373C49.6134 41.3793 49.9994 40.9933 49.9994 40.5172V25H24.9994L0.317383 41.1709Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.317383 8.829C0.466797 8.70459 0.651855 8.62061 0.861426 8.62061H49.1373C49.6134 8.62061 49.9994 9.00664 49.9994 9.48271V24.9999H24.9994L0.317383 8.829Z",
			fill: "#41479B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05371 27.8018C10.6011 27.8018 11.8555 26.5474 11.8555 25C11.8555 23.4526 10.6011 22.1982 9.05371 22.1982C7.50634 22.1982 6.25195 23.4526 6.25195 25C6.25195 26.5474 7.50634 27.8018 9.05371 27.8018Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.0541 24.9999L8.00342 20.7974L9.0541 19.3965L10.1047 20.7974L9.0541 24.9999Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.0541 25L10.1047 29.2025L9.0541 30.6034L8.00342 29.2025L9.0541 25Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05371 24.9999L4.85107 26.0506L3.4502 24.9999L4.85107 23.9492L9.05371 24.9999Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05371 24.9999L13.2562 23.9492L14.6571 24.9999L13.2562 26.0506L9.05371 24.9999Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05371 24.9999L11.2824 21.2854L13.0159 21.0376L12.7683 22.7711L9.05371 24.9999Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.0541 25L6.82529 28.7145L5.0918 28.9623L5.33955 27.2288L9.0541 25Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.0541 24.9999L5.33955 22.7711L5.0918 21.0376L6.82529 21.2854L9.0541 24.9999Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05371 25L12.7683 27.2288L13.0159 28.9623L11.2824 28.7145L9.05371 25Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.31204 12.8608L2.45814 13.9506L1.47415 14.4416C1.34681 14.5052 1.37357 14.6944 1.5137 14.7199L2.59534 14.9178L2.75823 16.0053C2.77933 16.1461 2.96751 16.179 3.03519 16.0536L3.55765 15.0861L4.64222 15.2671C4.78265 15.2906 4.8721 15.1217 4.77386 15.0188L4.01507 14.2229L4.52239 13.2473C4.58812 13.121 4.45511 12.9837 4.32679 13.0453L3.33538 13.5211L2.56439 12.737C2.46478 12.6357 2.29319 12.7197 2.31204 12.8608Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.74645 34.0727L2.56188 35.1567L1.47653 35.333C1.336 35.3559 1.30544 35.5444 1.43151 35.6104L2.40544 36.1209L2.23776 37.2076C2.21608 37.3483 2.3859 37.4356 2.48776 37.3361L3.27419 36.5676L4.25602 37.063C4.38317 37.1271 4.51872 36.9925 4.45563 36.8649L3.96774 35.8795L4.74215 35.0989C4.84235 34.9979 4.75641 34.8273 4.6154 34.8479L3.52731 35.0074L3.02418 34.0296C2.95905 33.9031 2.77018 33.9322 2.74645 34.0727Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8002 23.3942L19.1673 24.2935L18.1117 23.9858C17.975 23.946 17.8663 24.1031 17.9516 24.217L18.6113 25.0968L17.9924 26.0058C17.9123 26.1234 18.0281 26.2754 18.1628 26.2294L19.2034 25.8739L19.8766 26.7434C19.9638 26.856 20.1441 26.7927 20.1419 26.6504L20.1253 25.551L21.1603 25.1793C21.2943 25.1312 21.2899 24.9401 21.1539 24.8982L20.103 24.5742L20.0694 23.4751C20.0653 23.3326 19.8822 23.2777 19.8002 23.3942Z",
			fill: "#FFE15A"
		})
	]
});
const ForwardRef = forwardRef(SvgPhFlag);
export { ForwardRef as ReactComponent };
